import { render, staticRenderFns } from "./SubView.vue?vue&type=template&id=4062a46e&"
import script from "./SubView.vue?vue&type=script&lang=js&"
export * from "./SubView.vue?vue&type=script&lang=js&"
import style0 from "./SubView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports